import apiService from 'services/api.service'
import store from 'store'

export default {

    async getHotels() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'hotels/getHotelList',
                method: 'get',
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty data!')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async getMarkets() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'prices/getMarketList',
                method: 'get',
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty data!')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async getSeasonTypes(params) {
        const locale = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'contracts/getSeasonTypeList',
                method: 'get',
                params: params,
                locale: locale
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty data!')
                }
            }).catch(error => {
                reject(error);
            })
        })
    },

    async getRoomsPrices(params) {
        const locale = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/getRoomsPrices',
                method: 'get',
                params: params,
                locale: locale
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty data!')
                }
            }).catch(error => {
                reject(error);
            })
        })
    },

    async getMeals(params) {
        const locale = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'prices/getMealList',
                method: 'get',
                params: params,
                locale: locale
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty data!')
                }
            }).catch(error => {
                reject(error);
            })
        })
    },

    async getRooms(params) {
        const locale = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'prices/getRoomList',
                method: 'get',
                params: params,
                locale: locale
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty data!')
                }
            }).catch(error => {
                reject(error);
            })
        })
    },

    async getCurrencies() {
        const locale = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'prices/getCurrencyList',
                method: 'get',
                locale: locale
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty data!')
                }
            }).catch(error => {
                reject(error);
            })
        })
    },

    async getSpoTypes() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/getSpoTypeList',
                method: 'get',
                locale: lang
            }).then(response => {
                if (response.data.success) {
                    const spoTypes = response.data.data;
                    resolve(spoTypes);
                } else {
                    reject('empty spo types');
                }
            })
        })
    },

    async getSpoSubTypes() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/getSpoSubtypeList',
                method: 'get',
                locale: lang
            }).then(response => {
                if (response.data.success) {
                    const spoSubTypes = response.data.data;
                    resolve(spoSubTypes);
                } else {
                    reject('empty spo subtypes');
                }
            })
        })
    },

    async getKbTypes() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/getKbTypeList',
                method: 'get',
                locale: lang
            }).then(response => {
                if (response.data.success) {
                    const kbTypes = response.data.data;
                    resolve(kbTypes);
                } else {
                    reject('empty kb types');
                }
            })
        })
    },

    async getSpoList(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/getSpoList',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty special offers!')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async getSpoPrices(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/getSpoPriceList',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty spo prices!')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async removeSpo(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/delSpo',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                resolve(response);
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async saveSpo(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/setSpo',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async saveSpoPriceContract(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/setContract',
                method: 'post',
                params: params,
                locale: lang
            }).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async saveSpoPriceDiscount(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/setDiscount',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async saveSpoPriceRotation(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/setRotation',
                method: 'post',
                params: params,
                locale: lang
            }).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async getContract(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/getContract',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                if (response.data.success) {
                    resolve(response.data.data);
                } else {
                    reject('empty contract');
                }
            })
        })
    },

    async getDiscount(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/getDiscount',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                if (response.data.success) {
                    resolve(response.data.data);
                } else {
                    reject('empty contract');
                }
            })
        })
    },

    async getRotation(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/getRotation',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                if (response.data.success) {
                    resolve(response.data.data);
                } else {
                    reject('empty rotation');
                }
            })
        })
    },

    async removeSpoPriceContract(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/removeSpoPriceContract',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                resolve(response);
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async removeSpoPriceDiscount(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/removeSpoPriceDiscount',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                resolve(response);
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async removeSpoPriceRotation(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'spo/removeSpoPriceRotation',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                resolve(response);
            }).catch((error) => {
                reject(error)
            })
        })
    },

}
